module.exports = __webpack_public_path__ + "img/cAxtrkKs.83d9281d.svg";